<template>
    <AppLayout>
        <div class="max-w-7xl mx-auto px-4 py-6">
            <!-- Page Title -->
            <div class="mb-6">
                <h1 class="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                    {{ $tc('LBL_PROMOCODE', 2) }}
                </h1>
                <!-- Breadcrumb -->
                <nav
                    class="text-sm text-gray-500 mb-6 dark:text-gray-300"
                    aria-label="Breadcrumb"
                >
                    <ol class="flex items-center space-x-2">
                        <li class="flex items-center">
                            <inertia-link
                                :href="route('landing')"
                                class="text-green-600 hover:underline"
                            >
                                {{ $t('LBL_HOME') }}
                            </inertia-link>
                            <svg
                                class="w-3 h-3 mx-2 text-green-400"
                                fill="currentColor"
                                viewBox="0 0 320 512"
                            >
                                <path
                                    d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                                />
                            </svg>
                        </li>
                        <li class="text-gray-700">
                            {{ $tc('LBL_PROMOCODE', 1) }}
                        </li>
                    </ol>
                </nav>
            </div>
            <!-- breadcrumb end -->

            <div
                class="w-full bg-white dark:bg-gray-900 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 overflow-overflow"
            >
                <!-- Search & Action Bar -->
                <div class="flex flex-wrap items-center justify-end gap-4 p-4 sm:flex-nowrap">
                    <t-button
                        class="inline-flex items-center rounded-md"
                        variant="success"
                        @click="toggleRightSidebar"
                    >
                        <span>Add Promocode</span>
                    </t-button>
                </div>

                <div
                    class="w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-none shadow-md"
                >
                    <div class="overflow-x-auto">
                        <!-- Table content to list the Products -->
                        <table
                            class="min-w-[700px] w-full table-auto text-sm sm:text-base text-left text-gray-700 dark:text-gray-300"
                        >
                            <thead class="bg-gray-100 dark:bg-gray-700 text-sm font-semibold">
                                <tr>
                                    <th class="px-4 py-3">#</th>
                                    <th class="px-4 py-3">CODE</th>
                                    <th class="px-4 py-3">REWARD</th>
                                    <th class="px-4 py-3">REWARD TYPE</th>
                                    <th class="px-4 py-3">QUANTITY</th>
                                    <th class="px-4 py-3">DISPOSABLE</th>
                                    <th class="px-4 py-3">EXPIRY</th>
                                    <th class="px-4 py-3">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(row, rowIndex) in promocodes.data">
                                    <tr>
                                        <td class="px-4 py-3">{{ rowIndex + 1 + (currentPage - 1) * perPage }}</td>
                                        <td class="px-4 py-3">
                                            {{ row.code }}
                                        </td>
                                        <td class="px-4 py-3">
                                            {{ row.reward }}
                                        </td>
                                        <td class="px-4 py-3">
                                            {{ row.data.rewardType | capitalize }}
                                        </td>
                                        <td class="px-4 py-3">
                                            {{ row.quantity }}
                                        </td>
                                        <td class="px-4 py-3">
                                            {{ row.is_disposable }}
                                        </td>
                                        <td class="px-4 py-3">
                                            <span v-if="row.expires_at">
                                                {{ row.expires_at | fromNow }}
                                            </span>
                                            <span v-else> Never </span>
                                        </td>
                                        <td class="flex items-center px-4 py-3">
                                            <div
                                                v-if="moment().isAfter(row.expires_at)"
                                                class="text-red-500"
                                            >
                                                Disabled
                                            </div>
                                            <t-button
                                                v-else
                                                variant="groupwarn"
                                                size="sm"
                                                class="rounded-md"
                                                @click="deletePromocode(row.id)"
                                            >
                                                <span>Delete</span>
                                            </t-button>
                                        </td>
                                    </tr>
                                </template>
                                <tr
                                    v-if="!promocodes.data.length"
                                    class="text-center"
                                >
                                    <td
                                        colspan="8"
                                        class="px-4 py-4 text-gray-500 dark:text-gray-400"
                                    >
                                        {{ $t('LBL_DATA_FOUND') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div
                        v-if="promocodes.data.length"
                        class="flex justify-center items-center bg-gray-100 dark:bg-gray-800 px-4 py-4 border-t dark:border-gray-700"
                    >
                        <t-pagination
                            v-model="currentPage"
                            variant="rounded"
                            :total-items="totalRows"
                            :per-page="perPage"
                            :limit="limit"
                            :disabled="disabled"
                            @change="fetchPageData"
                        />
                    </div>
                    <p class="sm:hidden text-xs text-center text-gray-500 py-2">
                        ↔ Swipe left/right to scroll the table
                    </p>
                </div>
            </div>

            <!-- <div class="mt-4">
                <div>
                    <t-table
                        :responsive="true"
                        :responsive-breakpoint="640"
                        :headers="promoHeaders"
                        :data="promocodes.data"
                    >
                        <template
                            slot="tbody"
                            slot-scope="{ tbodyClass, trClass, tdClass, renderResponsive, data, headers }"
                        >
                            <template v-if="renderResponsive">
                                <tbody
                                    v-for="(row, rowIndex) in data"
                                    :key="rowIndex"
                                    :class="[tbodyClass, rowIndex % 2 === 0 ? 'bg-gray-100' : '']"
                                >
                                    <tr
                                        v-for="header in headers"
                                        :key="header.text"
                                        :class="trClass"
                                    >
                                        <th class="pl-1 text-sm font-semibold text-left text-gray-600 uppercase">
                                            {{ header.text }}
                                        </th>

                                        <td :class="[tdClass, 'relative']">
                                            <div v-if="header.text === 'Code'">
                                                {{ row.code }}
                                            </div>
                                            <div v-if="header.text === 'Reward'">
                                                {{ row.reward }}
                                            </div>
                                            <div v-if="header.text === 'Reward Type'">
                                                {{ row.data.rewardType | capitalize }}
                                            </div>
                                            <div v-if="header.text === 'Quantity'">
                                                {{ row.quantity }}
                                            </div>
                                            <div v-if="header.text === 'Disposable'">
                                                {{ row.is_disposable }}
                                            </div>
                                            <div v-if="header.text === 'Expiry'">
                                                <span v-if="row.expires_at">
                                                    {{ row.expires_at | fromNow }}
                                                </span>
                                                <span v-else> Never </span>
                                            </div>

                                            <div
                                                v-if="header.text === 'Actions'"
                                                class="flex flex-wrap items-center gap-1"
                                            >
                                                <div
                                                    v-if="moment().isAfter(row.expires_at)"
                                                    class="text-red-500"
                                                >
                                                    Disabled
                                                </div>
                                                <t-button
                                                    v-else
                                                    variant="error"
                                                    @click="deletePromocode(row.id)"
                                                >
                                                    Disable
                                                </t-button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </template>

                        <template
                            slot="row"
                            slot-scope="props"
                        >
                            <tr :class="[props.trClass, props.rowIndex % 2 === 0 ? 'bg-gray-100' : '']">
                                <td :class="props.tdClass">
                                    {{ props.row.code }}
                                </td>

                                <td :class="props.tdClass">
                                    {{ props.row.reward }}
                                </td>

                                <td :class="props.tdClass">
                                    {{ props.row.data.rewardType | capitalize }}
                                </td>

                                <td :class="props.tdClass">
                                    {{ props.row.quantity }}
                                </td>

                                <td :class="props.is_disposable">
                                    {{ props.row.is_disposable }}
                                </td>

                                <td :class="props.tdClass">
                                    <span v-if="props.row.expires_at">
                                        {{ props.row.expires_at | fromNow }}
                                    </span>
                                    <span v-else> Never </span>
                                </td>

                                <td :class="props.tdClass">
                                    <div
                                        v-if="moment().isAfter(props.row.expires_at)"
                                        class="text-red-500"
                                    >
                                        Disabled
                                    </div>
                                    <t-button
                                        v-else
                                        variant="error"
                                        @click="deletePromocode(props.row.id)"
                                    >
                                        Disable
                                    </t-button>
                                </td>
                            </tr>
                        </template>
                    </t-table>

                    <div class="my-4">
                        <t-pagination
                            v-model="currentPage"
                            :total-items="totalRows"
                            :per-page="perPage"
                            :limit="limit"
                            :disabled="disabled"
                            @change="fetchPageData"
                        />
                    </div>
                </div>
                <div v-if="!promocodes.data.length">No promocode available.</div>
            </div> -->
        </div>

        <RightSidebar
            :is-open="rightSidebar"
            :component-name="rightSidebarComponentName"
            @closeRightSidebar="toggleRightSidebar"
        >
            <template #heading>
                <!-- Title -->
                <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div class="flex items-center gap-3 min-w-0 flex-1">
                        <h2 class="text-xl font-semibold text-gray-800 dark:text-white">Promocode Information</h2>
                    </div>
                    <t-button
                        variant="text"
                        class="hover:text-red-500"
                        @click="rightSidebar = false"
                    >
                        ✕ Close
                    </t-button>
                </div>
            </template>
        </RightSidebar>
    </AppLayout>
</template>

<script>
    import Button from '../../Components/Button.vue';
    import AppLayout from '../../Layouts/AppLayout.vue';
    import RightSidebar from '../../Components/RightSidebar.vue';
    import CreateIcon from '../../Components/Icons/CreateIcon.vue';

    export default {
        name: 'PromocodeIndex',

        components: {
            AppLayout,
            RightSidebar,
            CreateIcon,
            Button,
        },

        props: {
            promocodes: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                rightSidebar: false,
                rightSidebarComponentName: 'PromocodeForm',

                promoHeaders: [
                    { value: 'code', text: 'Code' },
                    { value: 'reward', text: 'Reward' },
                    { value: 'data.rewardType', text: 'Reward Type' },
                    { value: 'quantity', text: 'Quantity' },
                    { value: 'is_disposable', text: 'Disposable' },
                    { value: 'expires_at', text: 'Expiry' },
                    { value: 'actions', text: 'Actions' },
                ],

                currentPage: null,
                limit: 5,
                perPage: this.promocodes.per_page,
                totalRows: this.promocodes.total,
            };
        },

        computed: {
            disabled() {
                return !this.promocodes.data.length;
            },
        },

        created() {
            this.currentPage = this.promocodes.current_page;
        },

        methods: {
            deletePromocode(promocodeId) {
                this.$inertia.delete(route('promocodes.destroy', promocodeId));
            },

            toggleRightSidebar() {
                this.rightSidebar = !this.rightSidebar;
            },

            fetchPageData(newPage) {
                this.$inertia.get(
                    route('promocodes.index', {
                        page: newPage,
                    }),
                );
            },
        },
    };
</script>
